export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.console': 'Admin',
  'menu.console.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgotPassword': 'Forgot Password',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.account.profile': 'Profile',
  'menu.console.agents': 'agents',
  'menu.console.agentDevice': 'agentDevice',
  'menu.console.devices': 'devices',
  'menu.console.speakers': 'Speaker Recognition',
  'menu.console.voiceClone': 'Voice Clone',
  'menu.console.knowledgeBases': 'Knowledge Bases',
  'menu.console.simRecharge': '4G / SIM recharge',
  'menu.console.settings': 'Personal Settings',
  'menu.admin': 'Admin',
  'menu.admin.dashboard': 'Dashboard',
  'menu.admin.dataScreen': 'Access Analysis',
  'menu.admin.settings': 'Settings',
  'menu.admin.providers': 'Model Providers',
  'menu.admin.unbindDevice': 'Device Unbind',
  'menu.admin.userManage': 'User Management',
  'menu.admin.systemConfig': 'System Config',
  'menu.admin.distributedNodesConfig': 'Distributed Nodes',
  'menu.admin.whiteList': 'Whitelist',
  'menu.admin.opsManage': 'Operations',
  'menu.admin.recorderManage': 'Recorder Management',
  'menu.admin.deviceManage': 'Device Management (Old)',
  'menu.admin.deviceBound': 'Device Management',
  'menu.admin.hologramCover': 'Hologram Cover',
  'menu.console.hologramCover': 'Hologram Display',
  'menu.console.hologram': 'Hologram',
  'menu.console.hologram.cover': 'Change cover',
  'menu.admin.agentsManage': 'Agents',
  'menu.admin.adminKnowledgeBases': 'Knowledge Bases',
  'menu.admin.productManage': 'Product Management',
  'menu.admin.productCategory': 'Product Categories',
  'menu.admin.roleTemplate': 'Role Templates',
  'menu.admin.rechargeManage': 'SIM recharge',
  'menu.admin.orderLedger': 'Order ledger',
  'menu.admin.firmwarePackage': 'Firmware packages',
  'menu.admin.feedbackManage': 'Feedback',
  'menu.admin.mcpToolGuard': 'MCP Tool Auth',
  'menu.admin.guardReport': 'Guard Report',

  'menu.tenant': 'Enterprise',
  'menu.tenant.tenantDashboard': 'Enterprise Dashboard',
  'menu.tenant.tenantInfo': 'Company profile',
  'menu.tenant.tenantLicense': 'Device licenses',
  'menu.tenant.tenantSubAccount': 'Sub-enterprises',
  'menu.tenant.tenantDeviceBound': 'Device management',
  'menu.tenant.tenantProductionToken': 'Production burn tokens',
  'menu.tenant.tenantMcpEndpoint': 'Enterprise MCP Endpoint',
'menu.tenant.tenantExtDb': 'Enterprise Data Bridge',
'menu.tenant.tenantLocationConfig': 'Location Keys',
  'menu.tenant.tenantTtsVoices': 'Enterprise TTS Voices',
  'menu.tenant.tenantProductCategory': 'Product categories',
  'menu.tenant.tenantRoleTemplate': 'Role templates',
  'menu.tenant.tenantFriendTemplates': 'Friend message templates',

  'menu.console.agentSetting': 'Agent Settings',
  'menu.console.developerGithub': 'Developer Auth',
  'menu.console.developerEnterprise': 'Enterprise Auth',
  'menu.console.openapi': 'Open Platform',
  'menu.console.openapi.overview': 'Overview',
  'menu.console.openapi.apps': 'Apps & Keys',
  'menu.console.openapi.logs': 'Usage Logs',
  'menu.console.consoleTodos': 'My Todos',
  'menu.console.consoleLedger': 'My Ledger',
  'menu.admin.openapiApps': 'Apps & Keys',
  'menu.admin.openapiPlanTiers': 'Plan Tiers',
  'menu.admin.openapiUsageLogs': 'Usage Audit',
  'menu.admin.openapiUsersUsage': 'User Usage',
  'menu.admin.openapiPartnerLinks': 'External User Links',
  'menu.admin.enterpriseApplications': 'Enterprise Applications',
  'menu.admin.adminTodos': 'Todo Management',
  'menu.admin.adminLedger': 'Ledger Management',
  'menu.admin.adminFriendTemplates': 'Friend Message Templates',
};
